import TableActions from './table-actions'
import TableBodyContent from './table-body-content'
import TableHeader from './table-header'
import TableInfo from './table-info'
import TableOverlay from './table-overlay'
import TableRoot from './table-root'
import TableRowsContent from './table-rows-content'
import TableSearchBar from './table-search'
import TableTabs from './table-tabs'
import TableWrapper from './table-wrapper'

export const Table = {
  Root: TableRoot,
  Info: TableInfo,
  tabs: TableTabs,
  Header: TableHeader,
  Overlay: TableOverlay,
  Wrapper: TableWrapper,
  Actions: TableActions,
  Body: TableBodyContent,
  SearchBar: TableSearchBar,
  RowContent: TableRowsContent,
}
